import * as React from 'react';
import InputField, { InputFieldProps } from './inputField';

const PasswordField = (props: InputFieldProps) => {
  return <InputField {...props} type="password" />;
};

export default PasswordField;
